import axios, { AxiosResponse, AxiosPromise } from 'axios';

interface IApplicationFormSubmitReponse {
    ERRORS: string;
    SUCCESS: boolean;
}

export const sendApplicationForm = (form: FormData): AxiosPromise<IApplicationFormSubmitReponse> => {
    if (__PROXY_URL__) {
        return axios.post(
            `${__PROXY_URL__}/local/form/requestFormHandler.php`,
            form
        );
    } else {
        return axios.post(
            'https://map.lenoblinvest.ru/local/form/requestFormHandler.php',
            form
        );
    }
};


export const sendErrorForm = (form: FormData): AxiosPromise<IApplicationFormSubmitReponse> => {
    if (__PROXY_URL__) {
        return axios.post(
            `${__PROXY_URL__}/local/form/errorFormHandler.php`,
            form
        );
    } else {
        return axios.post(
            'https://map.lenoblinvest.ru/local/form/errorFormHandler.php',
            form
        );
    }
};

export const sendDataUpdateForm = (form: FormData): AxiosPromise<IApplicationFormSubmitReponse> => {
    if (__PROXY_URL__) {
        return axios.post(
            `${__PROXY_URL__}/local/form/updateFormHandler.php`,
            form
        );
    } else {
        return axios.post(
            'https://map.lenoblinvest.ru/local/form/updateFormHandler.php',
            form
        );
    }
};
